import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { Check, Download, Mail, ArrowRight } from "lucide-react";

export default function ThankYou() {
  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: "#FAFAFA" }}>
      <Helmet>
        <title>Thank You! | AI StoryCraft Studio</title>
        <meta name="description" content="Your purchase is confirmed. Access your toolkit now." />
      </Helmet>

      <div className="max-w-lg w-full text-center">
        <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6" style={{ backgroundColor: "#DCFCE7" }}>
          <Check className="w-8 h-8" style={{ color: "#16A34A" }} />
        </div>

        <h1 className="text-2xl md:text-3xl font-extrabold mb-3" style={{ color: "#1F2937" }}>You're All Set! 🎉</h1>
        <p className="text-base mb-8 leading-relaxed" style={{ color: "#6B7280" }}>
          Your purchase is confirmed. Check your email for download links and access instructions.
        </p>

        <div className="bg-white rounded-xl p-6 mb-8 text-left space-y-4" style={{ border: "1px solid #E5E7EB" }}>
          <h3 className="font-bold text-base" style={{ color: "#1F2937" }}>What happens next:</h3>
          {[
            { icon: <Mail className="w-4 h-4" />, text: "Check your inbox for your access email (within 60 seconds)" },
            { icon: <Download className="w-4 h-4" />, text: "Download your toolkit files and templates" },
            { icon: <ArrowRight className="w-4 h-4" />, text: "Start with the AI Content Monetisation Playbook" },
          ].map((item, i) => (
            <div key={i} className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: "#EDE9FE", color: "#7C3AED" }}>
                {item.icon}
              </div>
              <span className="text-sm pt-1.5" style={{ color: "#374151" }}>{item.text}</span>
            </div>
          ))}
        </div>

        <div className="space-y-3">
          <Link to="/" className="inline-flex items-center gap-1.5 text-sm font-semibold no-underline transition-colors hover:underline" style={{ color: "#7C3AED" }}>
            Visit AI StoryCraft Studio <ArrowRight className="w-3.5 h-3.5" />
          </Link>
        </div>
      </div>
    </div>
  );
}
